import React from 'react';
import { Route, Switch, useRouteMatch  } from "react-router-dom";
import { Container } from 'react-bootstrap'

import '../../styles/catalogos/catalogos.css'
import EncuestaList from './encuesta/EncuestaList';
import AddEncuesta from './encuesta/AddEncuesta';

function EncuestaIndex(){
    const { path, url } = useRouteMatch();

    return(
        <Container fluid className="my-5">
            <Switch>
                <Route exact path={ path }><EncuestaList url={ url }/></Route>
                <Route exact path={`${path}/create`}><AddEncuesta /></Route>
            </Switch>
        </Container>
    )
}

export default EncuestaIndex